/* ============================================================
   Total Bodycare -me- | theme.js
   ============================================================ */

// ── Hero Slideshow ──
(function () {
  let hCur = 0;
  const hSlides = document.querySelectorAll('.hslide');
  const hDots   = document.querySelectorAll('.hdot');

  if (!hSlides.length) return;

  function goHero(n) {
    hSlides[hCur].classList.remove('active');
    hDots[hCur].classList.remove('active');
    hCur = (n + hSlides.length) % hSlides.length;
    hSlides[hCur].classList.add('active');
    hDots[hCur].classList.add('active');
  }

  // 自動再生（4秒ごと）
  setInterval(() => goHero(hCur + 1), 4000);

  // スワイプ対応
  let hTx = 0;
  const heroEl = document.getElementById('heroSection');
  if (heroEl) {
    heroEl.addEventListener('touchstart', e => { hTx = e.touches[0].clientX; });
    heroEl.addEventListener('touchend',   e => {
      const diff = hTx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goHero(hCur + (diff > 0 ? 1 : -1));
    });
  }

  // ドットのクリックをグローバルに公開
  window.goHero = goHero;
})();